import s from './ContainerWrapper.module.css';

export const ContainerWrapper = ({ children }) => {
  return <div className={s.container}>{children}</div>;
};
